import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DisplayDefinitionsService {
  public showCurrencyPairs = false;
  public showFixingSources = false;
  public showCutoffs = false;
  public showTradeStatus = false;
}
